import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={13.37}
    height={25.989}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 4879 9485"
    {...props}
  >
    <path
      d="M662 5834h3556c56 0 102 46 102 102s-46 102-102 102H662c-56 0-102-46-102-102s46-102 102-102zm3961-91c0 163-63 317-178 434l-851 865H1285l-851-865c-115-117-178-271-178-434v-258h4367v258zM1345 7608v-362h2190v362H1345zm2190 566H1345v-362h2190v362zm0 250c0 174-142 316-316 316H1661c-175 0-316-142-316-316v-46h2190v46zm-628 804h-935l-128-284h1191l-128 284zM256 662c0-224 182-406 406-406 223 0 405 182 405 406v4619H256V662zm2031 4619V1451c0-87 69-158 153-158s153 71 153 158v3830h-306zm153-5025c644 0 1168 536 1168 1195v3830h-812V1451c0-200-160-362-356-362-197 0-357 162-357 362v3830h-812V1451c0-659 524-1195 1169-1195zm1372 406c0-224 182-406 406-406 223 0 405 182 405 406v4619h-811V662zm406-609c-337 0-610 273-610 609v56c-537-886-1798-888-2337 0v-56c0-336-273-609-609-609S53 326 53 662v5081c0 217 83 422 236 577l852 866v422h-54c-56 0-102 46-102 102s46 102 102 102h54v362h-54c-56 0-102 46-102 102s46 102 102 102h54v46c0 273 211 497 479 518l193 430c17 37 53 60 93 60h1067c40 0 76-23 93-60l193-430c269-21 479-245 479-518l1-46h53c56 0 102-46 102-102s-46-102-102-102h-53v-362h53c56 0 102-46 102-102s-46-102-102-102h-53v-422l852-866c152-155 236-360 236-577V662c0-336-273-609-609-609z"
      style={{
        fill: "#2b2a29",
        // stroke: "#000",
        strokeWidth: 105.106,
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
